import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

import { SnackbarType } from './snackbar-config';

export interface SnackbarDataType {
  message: string;
  type: SnackbarType;
  actionButtonText?: string;
}

@Component({
  selector: 'tiime-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SnackbarComponent {
  private readonly snackBarRef = inject<MatSnackBarRef<SnackbarComponent>>(MatSnackBarRef);

  data: SnackbarDataType;
  isSuccessSnackbar: boolean;

  constructor() {
    const data = inject<SnackbarDataType>(MAT_SNACK_BAR_DATA);

    this.data = data;
    this.isSuccessSnackbar = data.type === SnackbarType.success;
  }

  close(): void {
    this.snackBarRef.dismissWithAction();
  }
}
